<template>
    <div class="card-panel card-lead">
        <div class="card-lead-actions">
            <slot name="actions"></slot>
        </div>
        <div class="flex-row middle-xs card-lead-body">
            <slot></slot>
        </div>
        <slot name="status">
            <div v-if="statusText" class="card-lead-status text-primary" :class="statusClass">
                {{ statusText }}
            </div>
        </slot>
    </div>
</template>

<script>
    export default {
        name: "lead-card",

        props: {
            statusText: String,
            statusClass: [Object, String]
        }
    }
</script>

<style lang="scss">
    @import '@/assets/sass/card-lead.scss';
</style>


// WEBPACK FOOTER //
// src/components/common/LeadCard.vue